import request from '@/utils/request2'

// 列表(主数据列表)
export function loadStoreLevelSettingListDataApi(data) {
  return request({
    url: 'tms-web/storeLevelSetting/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportStoreLevelSettingListDataApi(data) {
  return request({
    url: 'tms-web/storeLevelSetting/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveStoreLevelSettingApi(data) {
  return request({
    url: 'tms-web/storeLevelSetting/save',
    method: 'post',
    data
  })
}

// 作废
export function deleteStoreLevelSettingApi(data) {
  return request({
    url: 'tms-web/storeLevelSetting/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewStoreLevelSettingApi(data) {
  return request({
    url: 'tms-web/storeLevelSetting/view',
    method: 'post',
    data
  })
}

// 列表
export function listStoreLevelSettingApi(data) {
  return request({
    url: 'tms-web/storeLevelSetting/list',
    method: 'post',
    data
  })
}
